import { LoadableLazy } from '@confluence/loadable';

export const ReattachCommentPanelLoader = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ReattachCommentPanel" */ './ReattachCommentPanel.tsx'))
			.ReattachCommentPanel,
});
